<template>
  <section class="product-preview">
    <!--singular photo-->
    <PhotoPreview
      v-if="singleItem"
      :photo-url="item.thumbnail.url"
      :overlay-url="item.style === StyleType.Event ? (isPortrait ? item.event.eventOverlayPortrait : item.event.eventOverlayLandscape) : ''"
      :orientation="isPortrait ? 'portrait' : 'landscape'"
    />

    <div
      v-else
      class="photo-pack"
      :class="isPortrait ? 'portrait' : 'landscape'"
    >
      <div
        v-for="i in 3"
        :key="i"
        class="photo-pack-item"
      >
        <PhotoPreview
          :photo-url="item.thumbnail.url"
          :overlay-url="isPortrait ? item.event.eventOverlayPortrait : item.event.eventOverlayLandscape"
          :orientation="isPortrait ? 'portrait' : 'landscape'"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { PhotoPreview } from '@/components/galleries';
import { DeliveryType, PhotoType, StyleType } from '@/const.js';

const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
});

const singleItem = computed(() => {
  return props.item.type === PhotoType.Single;
});

const isPrintItem = computed(() => {
  return props.item.delivery === DeliveryType.Print;
});

const isPortrait = computed(() => props.item?.thumbnail?.dimensions.height > props.item?.thumbnail?.dimensions.width);
</script>
